"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var NewTop_module_scss_1 = __importDefault(require("./NewTop.module.scss"));
function NewTop() {
    var _a = (0, react_1.useState)(window.innerWidth), screenWidth = _a[0], setScreenWidth = _a[1];
    (0, react_1.useEffect)(function () {
        var handleResize = function () {
            setScreenWidth(window.innerWidth);
        };
        window.addEventListener("resize", handleResize);
        return function () {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    console.log(screenWidth);
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: NewTop_module_scss_1.default.newTop }, { children: [(0, jsx_runtime_1.jsx)("video", { autoPlay: true, loop: true, muted: true, playsInline: true, src: "https://loop-markets.directus.app/assets/cb98ad98-ba88-4e0f-861f-ef84a0a466eb" }), (0, jsx_runtime_1.jsx)("h1", { children: "Empowering Artists and Superfans" }), (0, jsx_runtime_1.jsx)("p", { children: "Stay in the Loop to support your Favourite Artists and get Exclusive Music, Benefits and Experiences" }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: NewTop_module_scss_1.default.buttons_top }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: NewTop_module_scss_1.default.button_top }, { children: (0, jsx_runtime_1.jsx)("a", __assign({ href: "https://app.loop.fans/clubs" }, { children: "Join an Artist's LOOP" })) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: NewTop_module_scss_1.default.button_top }, { children: (0, jsx_runtime_1.jsx)("a", __assign({ href: " https://loop.fans/stars" }, { children: "Create an Artist LOOP" })) }))] })) })] })));
}
exports.default = NewTop;
